import script from "./CommentThreadPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentThreadPanel.vue?vue&type=script&setup=true&lang=js"

import "./CommentThreadPanel.vue?vue&type=style&index=0&id=5043fc6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5043fc6e"]])

export default __exports__